import { render, staticRenderFns } from "./BtnExcluirDetalhesFaseEmLote.vue?vue&type=template&id=78bc773c"
import script from "./BtnExcluirDetalhesFaseEmLote.vue?vue&type=script&lang=js"
export * from "./BtnExcluirDetalhesFaseEmLote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports